 <template>
    <div class="alet_container">
        <div class="content">
            <img class="tip_icon" src="../assets/images/zp_title.png" alt="">
            <div class="tipCredit" v-if="lotteryDetail.user_have_credit">{{'当前积分数为:'+lotteryDetail.user_have_credit}}</div>
            <section id="turntable" class="gb-turntable">
                <div class="gb-turntable-container">
                    <canvas class="gb-turntable-canvas" width="300" height="300px">抱歉！浏览器不支持。</canvas>
                </div>
                <div class="gb-turntable-btn lottery-draw">
                    <p class="p1">抽奖</p>
                    <p class="p2" v-if="lotteryDetail.credit_desc!=''">{{lotteryDetail.credit_desc}}</p>
                </div>
                <div class="gb-circle-out">
                    <img src='../assets/images/bg.gif' alt="" @click='noPre(e)' class="gb-gift" style="display:none">
                    <img src="../assets/images/bg.png" alt="" @click='noPre(e)' class="gb-png">
                </div>
            </section>
            <div class="award_btn">
               <p @click="clickAward">我的中奖记录</p>
            </div>
        </div>
        <section class="tip_text_container" v-if="lotteryDetail.show_desc=='1'"><!-- 奖品说明 -->
            <div class="tip_award">
                <p>奖项说明</p>
            </div>
            <div class="awardList">
                <ul class="lists">
                    <li class="list" v-for="(item,index) in prizeListData" :key="index">
                        <p class="awardPic" v-if="prizeListImgDisplay" >
                            <img :src="item.image" alt="">
                        </p>
                        <p :class="prizeListImgDisplay?'pName':'pName_sec'">{{item.name}}</p>
                        <p :class="prizeListImgDisplay?'pDesc':'pDesc_sec'">{{item.desc}}</p>
                        <p :class="prizeListImgDisplay?'pSur':'pSur_sec'" v-if="lotteryDetail.show_prize_num=='1'">{{'剩余数量：'+item.prize_number}}</p>
                        <p v-if="!prizeListData.length">发布者暂时没有配置奖项</p>
                    </li>
                </ul>
            </div>
        </section>
        <section class="tip_text_container"><!-- 活动说明 -->
            <div class="tip_award">
                <p>活动说明</p>
            </div>
            <div class="awardList">
                <div class="lists" v-if="lotteryDetail.about_lottery">
                    <p class="explain">
                      <pre>{{lotteryDetail.about_lottery}}</pre>
                    </p>
                </div>
                <div class="lists" v-else>
                    <p class="explain" v-html="lotteryDetail.desc"></p>
                </div>
            </div>
        </section>
        <section class="foot">
            <div class="logo">
                <img :src="logo_img" alt="">
            </div>
        </section>
        <!-- 实物中奖弹窗 -->
        <formDialog
            :formDialogDisplay.sync="formDialogDisplay"
            :title="drawMsg.msg"
            :id="drawMsg.prize_receive_record_id"
            :formList="fillInfo">
        </formDialog>
    </div>

</template>

<script>
import FormDialog from 'components/formDialog/formDialog'

import '../assets/css/GB-canvas-turntable.css'//大转盘样式
import '../assets/js/GB-canvas-turntable.js'//大转盘canvas

import phone from '../assets/images/prize_phone.png'
import pad from '../assets/images/prize_pad.png'
import redbag from '../assets/images/prize_redbag.png'
import tick from '../assets/images/prize_tick.png'
import gift from '../assets/images/prize_gift.png'
import milk from '../assets/images/prize_milk.png'
import wifi from '../assets/images/prize_wifi.png'

import {logo_img} from '../config/config';
    export default {
        data() {
          return {
            logo_img,
            formDialogDisplay: false,
            defaultPic:{
                phone:phone,
                pad:pad,
                redbag:redbag,
                tick:tick,
                gift:gift,
                milk:milk,
                wifi:wifi
            },
            creditValue:'',
            validSubmit:true,
            clickOne:true,
            prizeList:[],
            drawId:'',//记录奖品ID
            drawMsg:'',
            dialogFillIn:false,
            fillInfo:{},
            formLabelWidth:'25%',
            fields:{},
            judge:{
                name:false,
                tel:false,
                idcard:false,
                add:false
            },
          }
        },
        props: ['lotteryDetail','prizeListData', 'preview', 'platRight', 'prizeListImgDisplay', 'coordinate'],
        watch: {
          prizeListData(val, oldVal) {
            this.wheelInit()
          }
        },
        created(){
          this.creditValue = this.lotteryDetail.credit;
          this.drawnumInit();
        },
        methods: {
          drawnumInit() {
              let vm = this
              this.Get({
                  url:'/activity/api.php',
                  data: {
                      m:'front',
                      subm:'lottery',
                      action:'drawnum',
                      preview: vm.preview,
                  },
                  success:function(data){
                      if(data.code == 3001) {
                          if(data.data.no_limit == 0) {
                              if(data.data.residue_count > 0) {
                                  vm.drawTip = `您还剩余${data.data.residue_count}次抽奖机会`
                              }else{
                                  vm.drawTip = '抽奖机会用完啦！'
                              }
                          }
                          /* 更新积分 */
                          vm.lotteryDetail.user_have_credit = data.data.user_have_credit
                      }
                  },
                  error: function(data){

                  }
              });
          },
          platRightCheck() {
              if (this.platRight && this.platRight.right === 0) {
              if (this.platRight.apptype === 'WX') {
                  this.$router.push('/wxScan')
              } else {
                  this.$dialog({
                    message: this.platRight.name,
                    url: this.platRight.url,
                    key: this.platRight.apptype
                  })
              }
              return true
              }
          },
          wheelInit() {
            let _this = this;
            let noPrize = ['谢谢参与','要加油噢','运气先攒着','再接再厉','祝您好运','不要灰心'];
            let j=0;
            let k=0;
            if (_this.lotteryDetail.prize_number=='0') {
                for(let i=0;i<12;i++){
                    if (i%2==0) {
                        _this.prizeList.push(noPrize[j]);
                        j++
                    }else{
                        if(i==1){
                            _this.prizeList.push('中奖啦');
                        }else{
                            _this.prizeList.push('');
                        }
                    }
                }
            }else{
                for(let i=0;i<12;i++){
                    if (i%2==0) {
                        _this.prizeList.push(noPrize[j]);
                        j++
                    }else{
                        _this.showPrize(i,k);
                        k++;
                    }
                }
            }

            gbTurntable.init({
                id: 'turntable',
                config: function(callback){
                    // 获取奖品信息
                    callback && callback(_this.prizeList);
                },
                getPrize: function(callback) {// 获取中奖信息
                    // 端检查
                    if (_this.platRightCheck()) return
                    if (_this.clickOne) {
                        _this.drawPrize(function(p,l){
                                callback(p,l);
                              _this.drawnumInit();
                        });
                    }
                },
                gotBack: function(data) {
                    _this.clickOne = true;
                    _this.fillInfo={}
                    if(_this.drawPrize.err_back) {
                        _this.$message({
                          type: 'error',
                          message: data.msg,
                          center:true,
                          onClose:function(){
                            _this.clickOne = true;
                          }
                        });
                    } else if (_this.drawMsg.prize_type=='1'&&_this.drawMsg.receive_msg.length!='0') {
                        _this.fields ={
                              m:'front',
                              subm:'lottery',
                              action:'receivemsg',
                              id:_this.drawMsg.prize_receive_record_id
                        }
                        for(var i=0;i<_this.drawMsg.receive_msg.length;i++){
                            var field =_this.drawMsg.receive_msg[i];
                            _this.fillInfo[field]='';
                        }
                        // 打开中奖表单弹窗
                         /* 延迟800ms出现弹框提示 */
                        setTimeout(() => {
                          _this.formDialogDisplay = true;
                        }, 800)
                        // _this.showField(_this.fillInfo);
                    }else{//虚拟奖品
                        let jp
                        if (_this.drawMsg.invented_prize_info && _this.drawMsg.invented_prize_info.verification) {
                            jp = _this.drawMsg.msg+'<br>'+_this.drawMsg.invented_prize_info.verification
                        }else{
                            jp = _this.drawMsg.msg;
                        }
                        if (_this.drawMsg.prize_type === 3) {
                          _this.alertPrize(jp, '立即领取', _this.drawMsg.prize_url)
                        } else {
                          _this.alertPrize(jp);
                        }
                    }
                }
            });
          },
          noPre(event){
              event.preventDefault();
          },
          clickAward(){
              // 端检查
              if (this.platRightCheck()) return
              this.$emit('clickAward')
          },
          alertPrize(){//中奖后的弹框
              this.$emit.apply(this,[].concat.apply(['alertPrize'], arguments));
          },
          drawPrize(callback) {
              let latitude, longitude
              if (this.coordinate) {
                  latitude = this.coordinate.latitude
                  longitude = this.coordinate.longitude
              }
              let _this = this;
              _this.clickOne = false;
              _this.Get({
                  url:'/activity/api.php',
                  data: {
                      m:'front',
                      subm:'lottery',
                      action:'drawprize',
                      preview: _this.preview,
                      lat: latitude || '',
                      lng: longitude || '',
                  },
                  success:function(data){
                      let prizeData = data.data;
                      _this.drawMsg = prizeData;
                      _this.creditValue = prizeData.credit;
                      if (prizeData.prize_id!=0&&_this.lotteryDetail.prize_number!='0') {
                          for(var i=0;i<_this.prizeList.length;i++){
                              if (_this.prizeList[i]==prizeData.prize_name) {
                                  _this.drawId = i;//奖品ID
                              }
                          }
                      }else{
                          let randNum = parseInt(Math.random()*12, 10);
                          if (prizeData.prize_id=='0') {//处理所有不中奖的操作
                              if (randNum%2==0) {
                                  _this.drawId = randNum;
                              }else{
                                  _this.drawId = randNum+1;
                              }
                          }else{//执行不显示奖品且中奖的操作
                              _this.drawId=1;
                              // if (randNum%2==0) {
                              //     _this.drawId = randNum;
                              // }else{
                              //     _this.drawId = randNum+1;
                              // }
                          }
                      }
                      callback && callback([_this.drawId, 1]);
                  },
                  error: function(data){
                      _this.drawMsg = {
                          err_back: true,
                          msg: data.msg,
                      };
                      let randNum = parseInt(Math.random()*12, 10);
                      if (randNum%2==0) {
                          _this.drawId = randNum;
                      }else{
                          _this.drawId = randNum+1;
                      }
                      callback && callback([_this.drawId, 1]);

                      if (data.code==5023) {
                          // _this.alertPrize(data.msg);
                          _this.clickOne = true;
                      }
                      if (data.code==5012) {
                          // _this.alertPrize(data.msg);
                          _this.clickOne = true;
                      }
                      if (data.code==5007||data.code == 5110||data.code==5011||data.code==5013||data.code==5014||data.code==5020||data.code==5107) {
                          _this.clickOne = true;
                          // _this.alertPrize(data.msg);
                          // _this.$router.replace('/');
                          // window.location.reload(true);
                      }
                      if (data.code==5108) {
                          // _this.alertPrize(data.msg);
                          _this.clickOne = true;
                      }
                      if (data.code==5009||data.code==5124||data.code==5025) {
                          _this.clickOne = true;
                          // _this.drawMsg = {
                          //     err_back: true,
                          //     msg: data.msg,
                          // };

                          // _this.$message({
                          //   type: 'error',
                          //   message: data.msg,
                          //   center:true,
                          //   onClose:function(){
                          //     _this.clickOne = true;
                          //   }
                          // });
                      }
                      if (data.code==5026) {
                          // _this.alertPrize(data.msg);
                          _this.clickOne = true;
                      }
                  }
              });
          },
          showPrize(i,k){
              let _this = this;
              let prizeLength = _this.prizeListData.length;
              switch(prizeLength){
                  case 1:
                      if (i==1||i==5||i==9) {
                          _this.prizeList.push(_this.prizeListData[0].name);
                      }else{
                          _this.prizeList.push('');
                      }
                      break;
                  case 2:
                      if (i==3||i==9) {
                          _this.prizeList.push(_this.prizeListData[0].name);
                      }else{
                          if (i==7||i==11) {
                              _this.prizeList.push(_this.prizeListData[1].name);
                          }else{
                              _this.prizeList.push('');
                          }
                      }

                      break;
                  case 3:
                      if (i==1||i==5||i==9) {
                          if (i==1) {
                              _this.prizeList.push(_this.prizeListData[0].name);
                          }
                          if (i==5) {
                              _this.prizeList.push(_this.prizeListData[1].name);
                          }
                          if (i==9) {
                              _this.prizeList.push(_this.prizeListData[2].name);
                          }
                      }else{
                          _this.prizeList.push('');
                      }

                      break;
                  case 4:
                      if (i==1||i==3||i==7||i==9) {
                          if (i==1) {
                              _this.prizeList.push(_this.prizeListData[0].name);
                          }
                          if (i==3) {
                              _this.prizeList.push(_this.prizeListData[1].name);
                          }
                          if (i==7) {
                              _this.prizeList.push(_this.prizeListData[2].name);
                          }
                          if (i==9) {
                              _this.prizeList.push(_this.prizeListData[3].name);
                          }
                      }else{
                          _this.prizeList.push('');
                      }
                      break;
                  case 5:
                      if (i==11) {
                          _this.prizeList.push('');
                      }else{
                          _this.prizeList.push(_this.prizeListData[k].name);
                      }
                      break;
                  case 6:
                      _this.prizeList.push(_this.prizeListData[k].name);
                      break;
                  default:
                      console.log('没有设置奖品');
                      break;
              }
          },
          showField(data){
              let _this = this;
              _this.judge={
                  name:false,
                  tel:false,
                  idcard:false,
                  add:false
              }
              if (data.hasOwnProperty("nickname")) {
                  _this.judge.name = true;
              }
              if (data.hasOwnProperty("telephone")) {
                  _this.judge.tel = true;
              }
              if (data.hasOwnProperty("idcard")) {
                  _this.judge.idcard = true;
              }
              if (data.hasOwnProperty("address")) {
                  _this.judge.add = true;
              }
              _this.dialogFillIn = true;
          },
          formSure(){
              let _this = this;
              _this.validSubmit = false;
              let isOK = true;
              for(let obj in _this.fillInfo){
                  _this.fields[obj] = _this.fillInfo[obj];
                  if(!_this.fillInfo[obj]) {
                      isOK = false,
                      _this.$message({
                          type: 'error',
                          message: '请填写完整信息',
                          center:true,
                          onClose:function(){
                            _this.validSubmit = true;
                          }
                      });
                      break;
                  }else{
                    if (obj=='name') {
                      const n = _this.fillInfo.name;
                      if (n.length>20) {
                        isOK = false,
                        _this.$message({
                            type: 'error',
                            message: '请输入正确姓名',
                            center:true,
                            onClose:function(){
                              _this.validSubmit = true;
                            }
                        });break;
                      }
                    }
                    if (obj=='telephone') {
                      const telephone = _this.fillInfo.telephone;
                      let r = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                      if (!r.test(telephone)) {
                        isOK = false,
                        _this.$message({
                            type: 'error',
                            message: '手机号码格式不正确',
                            center:true,
                            onClose:function(){
                              _this.validSubmit = true;
                            }
                        });break;
                      }
                    }
                    if (obj=='idcard') {
                      const c = _this.fillInfo.idcard;
                      let isOKCard = _this.validate_required(c);
                      if (!isOKCard) {
                        isOK = false,
                        _this.$message({
                            type: 'error',
                            message: '填写正确的身份证信息',
                            center:true,
                            onClose:function(){
                              _this.validSubmit = true;
                            }
                        });
                        break;
                      }
                    }
                    if (obj=='address') {
                      const adrs = _this.fillInfo.address;
                      if (adrs.length>50) {
                        isOK = false,
                        _this.$message({
                            type: 'error',
                            message: '最多地址只能输入50个字',
                            center:true,
                            onClose:function(){
                              _this.validSubmit = true;
                            }
                        });break;
                      }
                    }
                  }
              }
              if (isOK) {
                  _this.validSubmit = true;
                  // 添加预览信息
                  this.fields.preview = this.preview
                  _this.ajaxPost({
                      url:'/activity/api.php',
                      data: _this.fields,
                      success:function(data){
                        _this.dialogFillIn = false;
                      },
                      error: function(data){

                      }
                  });
              }
          },
          validate_required(code){
              //身份证号合法性验证
              //支持15位和18位身份证号
              //支持地址编码、出生日期、校验位验证
              let city={11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江 ",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北 ",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏 ",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外 "};
              let tip = "";
              let pass= true;
              if(!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)){
                  tip = "身份证号格式错误";
                  // tip = "请填写正确的身份证信息"
                  pass = false;
              }
              else if(!city[code.substr(0,2)]){
                  tip = "地址编码错误";
                  // tip = "请填写正确的身份证信息"
                  pass = false;
              }
              else{
                  //18位身份证需要验证最后一位校验位
                  if(code.length == 18){
                    code = code.split('');
                    //∑(ai×Wi)(mod 11)
                    //加权因子
                    let factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];
                    //校验位
                    let parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
                    let sum = 0;
                    let ai = 0;
                    let wi = 0;
                    for (let i = 0; i < 17; i++){
                      ai = code[i];
                      wi = factor[i];
                      sum += ai * wi;
                    }
                    let last = parity[sum % 11];
                      if(parity[sum % 11] != code[17]){
                        tip = "校验位错误";
                            // tip = "请填写正确的身份证信息"
                            pass =false;
                      }
                  }
              }
              return pass;
          }
        },
        components: {
            FormDialog
        }
    }
</script>
<style>
    .tipCredit{
        margin: 3% 0;
    }
    .alet_container .el-dialog__wrapper{
        position: absolute;
    }
    .gb-circle-out img{
        pointer-events: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -webkit-user-select:none;
        -o-user-select:none;
        user-select:none;
    }
</style>



// WEBPACK FOOTER //
// src/components/turntable.vue